export const ScrollTop = () => {
    function hideAndShow(backtop, head, scrollPos) {
        if (scrollPos > (head - 300)) {
            backtop.classList.remove('hide');
            backtop.classList.add('show');
        } else {
            backtop.classList.add('hide');
            backtop.classList.remove('show');
        };
    }
    document.addEventListener("scroll", (event) => {
        let backtop = document.getElementById('backtop');
        let head = window.innerHeight;
        let scrollPos = window.scrollY;
        hideAndShow(backtop, head, scrollPos);
    })
}